module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/logotipo_blanco-7026ae208b6edaa0cdea8c82349b1294.svg";